import { throttle } from 'throttle-debounce'

/**
 * 向下 scroll 加载更多 (节流)
 * @param {Function} request      请求方法
 * @param {Function} isValid      检查是否可继续执行
 * @param {Object} param2         参数选项，见参数名
 * @returns
 */
export const loadMore = (request, isValid, { delay = 100, bottom = 100, scrollingElement } = {}) => {
  if (!isValid) {
    return console.error('The method isValid is required!')
  }
  if (!scrollingElement) {
    scrollingElement = document.scrollingElement
  }
  return throttle(delay, () => {
    if (isValid()) {
      const { scrollTop, clientHeight, scrollHeight } = scrollingElement
      if (scrollTop + clientHeight > scrollHeight - bottom) {
        request()
      }
    }
  })
}

// 设置 scroll listener, 参数同方法 loadMore
export const setScrollListener = function () {
  if (!arguments.length) {
    return console.error('Listener params is required!')
  }
  const scrollListener = loadMore.apply(null, arguments)
  window.addEventListener('scroll', scrollListener)
  return scrollListener
}

// 移除 scroll listener
export const removeScrollListener = function (listener = null) {
  window.removeEventListener('scroll', listener)
}

// 滑动到页面顶部
export function backToTop() {
  const scrollElement = document.scrollingElement

  function step() {
    const progress = Math.ceil(scrollElement.scrollTop / 10)
    scrollElement.scrollTop -= Math.max(progress, 50)
    if (scrollElement.scrollTop > 0) {
      window.requestAnimationFrame(step)
    } else {
      scrollElement.scrollTop = 0
    }
  }

  window.requestAnimationFrame(step)
}
